<template>
  <div id="cropmedispatcher">
    <Menutop></Menutop>

    <div class="row container">
      <div class="col">


        <h1>Hier ist frontend/cropmedispatcher</h1>

        <div v-if="customers_mit_offenen_vorgaengen.length == 0">
          Keine offenen Vorgänge gefunden...
        </div>

        <div v-if="customers_mit_offenen_vorgaengen.length > 0">
          <ul>
            <li><a href="/frontend">home</a></li>
            <li v-for="(eincustomer,i ) in customers_mit_offenen_vorgaengen" :key="`${i}`">
              <router-link :to="'/cropme/' + eincustomer['customer']">
                <a>gehe zu {{ eincustomer['customer'] }} ({{ eincustomer['anzahl_offene_vorgaenge'] }} offene Vorgänge)</a></router-link>
              
            </li>
          </ul>
        </div>

      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios';
import Menutop from '../components/Menutop.vue';
import Footer from '../components/Footer.vue';

// Mixin fuer diese Komponente importieren
import loginzustand from './mixins/loginzustand.js';
import commonvars from './mixins/commonvars.js';

export default {
  components: {
    Menutop,
    Footer
  },
  mixins: [
    loginzustand,
    commonvars
  ],
  data() {
    return {
      customers: []
    }
  },
  computed: {
    customers_mit_offenen_vorgaengen() {
      return this.customers.filter(
        item => {
          return item['anzahl_offene_vorgaenge'] > 0
        }
      );
    },
  },
  mounted: function() {
    this.api_loginzustand_feststellen();
    this.hole_vorgangsinfos_fuer_alle_customers();
  },
  methods: {
    api_uebersicht_url() {
      return this.server_base_url()
          + '/api/alle/uploader/uebersicht';
    },
    hole_vorgangsinfos_fuer_alle_customers() {
    let url = this.api_uebersicht_url();
    console.log(url);
    axios
        .get (url)
        .then(
        response => {
            console.log(response.data);
            this.customers = response.data["customers"];
          
        }
      ); 
    },
  }
}
</script>